function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import { subscribe } from "../../../utils/pubsub";
export var isAfterPageView = function() {
    if (typeof window === "undefined") {
        return function() {
            return false;
        };
    }
    var after = false;
    window.addEventListener("after-page-view", function() {
        after = true;
    });
    subscribe("pageView", function() {
        after = false;
    });
    return function() {
        return after;
    };
}();
export var extractTrackingInfoFromTargetMbox = function(mbox) {
    var tmp = mbox.options, _ref = _sliced_to_array(tmp === void 0 ? [
        {}
    ] : tmp, 1), _ref_ = _ref[0], tmp1 = _ref_.responseTokens, _ref1 = tmp1 === void 0 ? {} : tmp1, experience = _ref1["experience.name"];
    var tmp2 = mbox.options, _ref2 = _sliced_to_array(tmp2 === void 0 ? [
        {}
    ] : tmp2, 1), _ref_1 = _ref2[0], type = _ref_1.type, content = _ref_1.content;
    // <Special Case Handler> for Adobe Target Remote Offers which return as type html but contain json payloads
    try {
        var parsedContent = JSON.parse(content);
        // fields is a object level definition of props from Contentful payload
        var fields = parsedContent.fields;
        if (fields) {
            content = fields;
            type = "json";
        }
    } catch (err) {
    // Continue
    }
    // </Special Case Handler>
    switch(type){
        case "html":
            {
                var html = content.trim();
                if (html) {
                    var div = document.createElement("div");
                    div.innerHTML = html;
                    for(var i = 0; i < div.childNodes.length; i += 1){
                        var _attrs, _attrs1;
                        var child = div.childNodes[i];
                        var attrs = Object.values(child.attributes).reduce(function(acc, attr) {
                            acc[attr.name] = attr.value;
                            return acc;
                        }, {});
                        var evar = (_attrs = attrs) == null ? void 0 : _attrs["data-evar"];
                        var value = ((_attrs1 = attrs) == null ? void 0 : _attrs1["data-evar-value"]) || experience;
                        if (evar) {
                            return {
                                evar: evar,
                                value: value
                            };
                        }
                    }
                }
                return {};
            }
        case "json":
            {
                var evar1 = content.evar, tmp3 = content.evarValue, value1 = tmp3 === void 0 ? experience : tmp3;
                return {
                    evar: evar1,
                    value: value1
                };
            }
        default:
            return {};
    }
};

//# sourceMappingURL=utils.js.map